<template>
  <svg
    v-bind="$attrs"
    :width="size"
    :height="size"
    xmlns="http://www.w3.org/2000/svg"
    class="ui-svg-inline"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM20,20H4V4H20Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'
import '../utils/style.css'

export default defineComponent({
  name: 'UilSquare',
  props: {
    size: {
      type: String,
      default: '1em'
    }
  }
})
</script>